<template>
    <bottom-sheet
            title="給予打賞"
            description="您的打賞，將給騎士更多的動力。"
            @onCancel="onCancel"
            @onConfirm="checkDonate"
            @onClose="onClose">
        <div class="input">
            <input type="number" v-model.number="donate" @keyup.enter="$event.target.blur()" placeholder="自訂金額" ref="donate">
            <img  v-show="donate" class="btn" @click="donate = ''" src="@/assets/img/cancel.svg">
        </div>
        <div class="select">
            <div class="item" @click="setDonate(50)">$ 50</div>
            <div class="item" @click="setDonate(100)">$ 100</div>
        </div>
        <div class="select">
            <div class="item" @click="setDonate(150)">$ 150</div>
            <div class="item" @click="setDonate(500)">$ 500</div>
        </div>
        <div v-if="canCancel" class="cancel" @click="clearDonate">
            不增加費用
        </div>
        <donate-modal ref="modal" @onConfirm="onConfirm"/>
        <select-payment v-if="showSelectPayment" :donate="donate" :only-online="true" :payment="payment" @onClose="showSelectPayment = false" @selectPayment="selectPayment"/>
        <loading loader="spinner"
                 :active="isLoading"
                 :width="25"
                 :height="25"
                 :is-full-page="true"/>
    </bottom-sheet>
</template>

<script>
    import BottomSheet from '../BottomSheet';
    import DonateModal from "../modal/DonateModal";
    import SelectPaymentType from "../checkout/SelectPaymentType";
    import {mapGetters} from 'vuex';
    import * as apis from "../../../apis";
    import Swal from "sweetalert2";
    import Loading from "vue-loading-overlay";

    export default {
        name: 'AddDonate',
        components: {
            'bottom-sheet': BottomSheet,
            'donate-modal': DonateModal,
            'select-payment': SelectPaymentType,
            'loading': Loading,
        },
        props: {
            defaultDonate: {
                default: 0,
            },
            canCancel: {
                default: false,
            },
            orderId: {
                required: true,
            }
        },
        data() {
            return {
                donate: undefined,
                showSelectPayment: false,
                payment: 'credit',
                agreement: null,
                isLoading: false,
            };
        },
        computed: {
            ...mapGetters(['agreements'])
        },
        methods: {
            selectPayment(payment) {
                this.isLoading = true;
                this.showSelectPayment = false;
                this.payment = payment;
                if (payment !== 'credit') {
                    this.agreement = this.agreements.find(a => parseInt(a.id) === parseInt(payment));
                }

                let payload = {
                    id: this.orderId,
                    data: {
                        type: this.payment,
                        return_url: location.pathname,
                        price: Math.max(parseInt(this.donate), 0),
                    }
                };

                if (this.payment !== 'credit' && this.payment !== 'cash') {
                    payload.data.type = 'agreement';
                    payload.data.agreement_id = this.payment;
                }

                apis.donate(payload).then(res => {
                    if (res.data.pay_url) {
                        window.location.replace(res.data.pay_url);
                    }
                    Swal.fire({
                        title: '感謝您的打賞',
                        text: '祝您有個美好的一天',
                        type: 'success',
                        allowOutsideClick: false,
                        showConfirmButton: false,
                        timer: 2000
                    }).then(() => {
                        this.$emit('onDone', Math.max(parseInt(this.tip), 0));
                    }).finally(() => {
                        this.isLoading = false;
                    })
                }).catch(err => {
                    Swal.fire({
                        type: 'error',
                        title: 'Oops...',
                        text: err.response.data.message,
                    });
                    this.isLoading = false;
                });
            },
            checkDonate() {
                this.$refs.modal.show(this.donate);
            },
            onConfirm() {
                this.showSelectPayment = true;
            },
            onClose() {
                this.$emit('onCancel');
            },
            onCancel() {
                this.$emit('onCancel');
            },
            setDonate(donate) {
                this.donate = donate;
                this.checkDonate();
            },
            clearDonate() {
                this.donate = '';
                this.$emit('onDone', this.donate);
            }
        },
        created() {
            if (this.defaultDonate > 0) {
                this.donate = this.defaultDonate
            }

            let agreement = this.agreements.find(agreement => agreement.is_default);

            if (agreement) {
                this.payment = agreement.id;
                this.agreement = agreement;
            }
        },
        watch: {
            donate() {
                if (this.donate !== Math.floor(this.donate)) {
                    this.donate = Math.floor(this.donate) || '';
                }
            }
        }
    };
</script>

<style lang="scss" scoped>
    input {
        border: 1px solid rgba(230,232,237,1);
        border-radius: 4px;
        background-color: rgba(255,255,255,1);
        width: calc(100% - 4px);
        height: 40px;
        text-align: center;
    }

    .cancel {
        border: 1px solid rgba(230,232,237,1);
        border-radius: 4px;
        width: calc(100% - 4px);
        height: 40px;
        text-align: center;
        margin-top: 10px;
        line-height: 40px;
    }

    .select {
        margin-top: 10px;
        display: flex;
        justify-content: space-around;

        .item {
            width: calc(50% - 7.5px);
            height: 40px;
            text-align: center;
            border: 1px solid rgba(230,232,237,1);
            border-radius: 4px;
            background-color: rgba(255,255,255,1);
            display: flex;
            justify-content: center;
            align-items: center;
        }
    }

    .input {
        position: relative;

        .btn {
            position: absolute;
            top: 0;
            right: 2px;
            height: 26px;
            width: 26px;
            line-height: 20px;
            margin: 10px;
        }
    }
</style>
